import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import Draggable from "react-draggable";
import API from "../../utils/API";
import parse from "html-react-parser";
import { PDFObject } from "react-pdfobject";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function ReportViewer(props) {
  const [htmlReport, setHtmlReport] = React.useState();
  const [reportUrl, setReportUrl] = React.useState("");

  const [showPopupReport, setShowPopupReport] = React.useState(false);
  const [popUpReportParams, setPopUpReportParams] = React.useState();
  const [popupReportTitle, setPopupReportTitle] = React.useState("Report");
  const [popupReportWidth, setPopupReportWidth] = React.useState("md");

  React.useEffect(() => {
    if (props.reportParams) generateReport();
  }, [props.reportParams]);

  function htmlClick(event, action, title, size) {
    setPopUpReportParams(JSON.parse("{" + action + "}"));
    setShowPopupReport(true);
    setPopupReportTitle(title);
    setPopupReportWidth(size);
  }

  async function generateReport() {
    if (props.reportParams.outFormat === "html") {
      let { data } = await API.post("/report/generate", props.reportParams);
      let parsed = parse(data, {
        replace: (domNode) => {
          //
          if (
            domNode &&
            domNode.attribs &&
            domNode.attribs.report_link &&
            domNode.attribs.report_link === "pos_report_link"
          ) {
            console.log(domNode);
            return (
              <div
                style={{ color: "blue" }}
                onClick={(event) => {
                  htmlClick(
                    event,
                    domNode.attribs.report_params,
                    domNode.attribs.report_title,
                    domNode.attribs.report_window_size
                  );
                }}
              >
                <u>{domNode.attribs.report_value}</u>
              </div>
            );
          }
        },
      });

      setHtmlReport(parsed);
    }
    if (props.reportParams.outFormat === "pdf") {
      let { data } = await API.post("/report/generate", props.reportParams);
      setReportUrl(data.fileName);
    }
  }

  const handleClickOpen = () => {
    props.setOpen(true);
  };

  const handleClose = () => {
    props.setOpen(false);
  };
  return (
    <div>
      <Dialog
        open={true}
        maxWidth={props.maxWidth ? props.maxWidth : "md"}
        fullWidth={true}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {props.title ? props.title : "Report"}
        </DialogTitle>
        <DialogContent>
          {htmlReport && <DialogContentText>{htmlReport}</DialogContentText>}
          {reportUrl && reportUrl.length > 0 && (
            <PDFObject
              url={reportUrl}
              height={"100vh"}
              pdfOpenParams={{ PageMode: "bookmarks", view: "FitV" }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>CLose</Button>
        </DialogActions>
      </Dialog>
      {showPopupReport && (
        <ReportViewer
          reportParams={popUpReportParams}
          open={showPopupReport}
          setOpen={setShowPopupReport}
          title={popupReportTitle}
          maxWidth={popupReportWidth}
        ></ReportViewer>
      )}
    </div>
  );
}
